import React from 'react';
import { ILine as Line } from '../../../../global';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Status from '../Status';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import IconButton from '@material-ui/core/IconButton';
import LineName from '../LineName';

const useStyles = makeStyles((theme: any) => ({
  card: {
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  rowSpacing: { marginBottom: theme.spacing(1) },
  status: { marginLeft: 'auto' },
  expandButton: {
    padding: 0,
    marginLeft: theme.spacing(0.5),
    marginRight: -theme.spacing(0.5),
  },
}));

export interface Props {
  line: Line;
  expanded: boolean;
  handleExpandClick: () => void;
  updateLineInfo?: (...args) => void;
  addOrDeleteError?: (...args) => void;
}

export default function LineNameRow({
  line,
  expanded,
  updateLineInfo = () => {},
  addOrDeleteError = () => {},
  handleExpandClick,
}: Props) {
  const classes = useStyles();

  return (
    <>
      <LineName
        line={line}
        handleEditActiveLineDetails={() => {}}
        setLineInfoDuringEdit={updateLineInfo}
        addOrDeleteError={addOrDeleteError}
      />
      <div className={classes.status}>
        <Status status={line.status} isClickable={false} />
      </div>
      {!line.edit && (
        <IconButton
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
          className={classes.expandButton}
        >
          {expanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
        </IconButton>
      )}
    </>
  );
}
